export default __webpack_public_path__ + "static/media/smart-contracts-home-animation-mobile.fc788898.png";